module.exports = __webpack_public_path__ + "static/img/honour5.f08c817.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/honour5.png
// module id = EnLV
// module chunks = 1